
import { $axios } from "@/utils/http.js";
import prefix from "../base.js";

export default {
  //获取活动模块中奖记录
  getModulePrizeRecord(data) {
    return $axios(`${prefix.prize}/get_prize_record`, data, "GET");
  },
  //抽奖
  drawPrize(data) {
    return $axios(`${prefix.prize}/draw_prize`, data, "POST");
  },
  //领奖
  receivePrize(data) {
    return $axios(`${prefix.prize}/receive_prize`, data, "POST");
  },
};

